import dynamicImport from 'components/dynamicImport';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import Default from './RoundPriceEditDefault';

const RoundPriceEditContent = dynamicImport({
  component: '/containers/Sale/RoundSection/RoundPriceEdit',
  fallback: Default,
});

@observer
class RoundPriceEdit extends Component {
  render() {
    return <RoundPriceEditContent {...this.props} />;
  }
}

export default RoundPriceEdit;



// WEBPACK FOOTER //
// ./src/app/containers/Sale/RoundSection/RoundPriceEdit.jsx